import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { TranslatedCopy } from '../../intl';

import { RULESET_MIN } from '~APP_UTIL/formValidations';

export const MinMaxQuantityRule = ({ type, value, appendClass }) => (
  <div className={classnames('text-color-secondary', appendClass)}>
    <TranslatedCopy
      id={type === RULESET_MIN ? 'pdp.minmax.min.copy' : 'pdp.minmax.max.copy'}
      values={{ amount: value }}
    />
  </div>
);

MinMaxQuantityRule.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  appendClass: PropTypes.string
};

MinMaxQuantityRule.defaultProps = {
  appendClass: ''
};

export default MinMaxQuantityRule;
